import { useState, useEffect } from 'react';
import { useLanguage } from '@/context/LanguageContext';

export const Countdown = ({ targetDate }) => {
    const { t } = useLanguage();
    const [timeLeft, setTimeLeft] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    });

    useEffect(() => {
        const calculateTimeLeft = () => {
            const difference = new Date(targetDate) - new Date();
            
            if (difference > 0) {
                setTimeLeft({
                    days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                    hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                    minutes: Math.floor((difference / 1000 / 60) % 60),
                    seconds: Math.floor((difference / 1000) % 60)
                });
            }
        };

        calculateTimeLeft();
        const timer = setInterval(calculateTimeLeft, 1000);

        return () => clearInterval(timer);
    }, [targetDate]);

    const timeUnits = [
        { label: t('home.countdown.days'), value: timeLeft.days },
        { label: t('home.countdown.hours'), value: timeLeft.hours },
        { label: t('home.countdown.minutes'), value: timeLeft.minutes },
        { label: t('home.countdown.seconds'), value: timeLeft.seconds }
    ];

    return (
        <div className="flex items-center justify-center gap-3 sm:gap-6">
            {timeUnits.map((unit, index) => (
                <div key={unit.label} className="flex items-center gap-3 sm:gap-6">
                    <div className="text-center">
                        <div className="relative">
                            <div className="w-16 sm:w-20 h-16 sm:h-20 rounded-lg bg-primary-foreground/10 backdrop-blur-sm border border-primary-foreground/20 flex items-center justify-center">
                                <span className="countdown-number text-3xl sm:text-4xl font-display font-bold text-accent">
                                    {String(unit.value).padStart(2, '0')}
                                </span>
                            </div>
                        </div>
                        <p className="mt-2 text-xs sm:text-sm text-primary-foreground/60 uppercase tracking-wider font-medium">
                            {unit.label}
                        </p>
                    </div>
                    {index < timeUnits.length - 1 && (
                        <span className="text-2xl sm:text-3xl text-accent/50 font-light mb-6">:</span>
                    )}
                </div>
            ))}
        </div>
    );
};

export default Countdown;
